// Inline SVG flags: emoji flags don't render on Windows (they show "GB"/"GE").
const FLAG_CLASS_NAME = "h-4 w-6 rounded-[3px] ring-1 ring-black/10";

export function GeorgianFlag() {
  return (
    <svg viewBox="0 0 300 200" className={FLAG_CLASS_NAME} aria-hidden="true">
      <path fill="#fff" d="M0 0h300v200H0z" />
      <path fill="#f00" d="M130 0h40v200h-40zM0 80h300v40H0z" />
      <path
        fill="#f00"
        d="M59 23h12v34H59zM48 34h34v12H48zM229 23h12v34h-12zM218 34h34v12h-34zM59 143h12v34H59zM48 154h34v12H48zM229 143h12v34h-12zM218 154h34v12h-34z"
      />
    </svg>
  );
}

// Drawn at 3:2 (not the official 2:1) so it fills the same box as the
// Georgian flag instead of being letterboxed.
export function UKFlag() {
  return (
    <svg viewBox="0 0 45 30" className={FLAG_CLASS_NAME} aria-hidden="true">
      <clipPath id="uk-flag-diagonals">
        <path d="M22.5 15h22.5v15zv15H0zH0V0zV0h22.5z" />
      </clipPath>
      <path fill="#012169" d="M0 0h45v30H0z" />
      <path stroke="#fff" strokeWidth="6" d="M0 0l45 30m0-30L0 30" />
      <path
        stroke="#C8102E"
        strokeWidth="4"
        clipPath="url(#uk-flag-diagonals)"
        d="M0 0l45 30m0-30L0 30"
      />
      <path stroke="#fff" strokeWidth="10" d="M22.5 0v30M0 15h45" />
      <path stroke="#C8102E" strokeWidth="6" d="M22.5 0v30M0 15h45" />
    </svg>
  );
}
